import {POSTERMYWALL_FORM_TEXT_TYPE} from '@FormMakerReact/components/postermywall-form-text/postermywall-form-text';
import {registerRightPanelSector} from '@FormMakerReact/layout/form-maker-right-panel/right-panel-registry';
import {LabelFontControl} from '@FormMakerReact/layout/form-maker-right-panel/sectors/label-sector/components/label-font-control/label-font-control';
import {LabelSizeControl} from '@FormMakerReact/layout/form-maker-right-panel/sectors/label-sector/components/label-size-control/label-size-control';
import {LabelTextColorControl} from '@FormMakerReact/layout/form-maker-right-panel/sectors/label-sector/components/label-text-color-control/label-text-color-control';

registerRightPanelSector(POSTERMYWALL_FORM_TEXT_TYPE, {
  title: window.i18next.t('pmwjs_form_maker_label_sector_title'),
  controls: [LabelFontControl, LabelSizeControl, LabelTextColorControl],
});
